import React from 'react';
import { IconProps } from '.';

const SvgHomeSetting = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M18.995 7.7 12 1.498 1.502 10.805 2 12.117h1.75V22.25h6.604a1.496 1.496 0 0 1-1.004-.72l-.45-.78H5.25V10.617H3.976L12 3.502 16.734 7.7h2.261Z'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M16.001 13.15c-1.585 0-2.909 1.258-2.909 2.85s1.324 2.85 2.91 2.85c1.584 0 2.908-1.258 2.908-2.85s-1.324-2.85-2.909-2.85ZM14.592 16c0-.724.613-1.35 1.41-1.35.795 0 1.408.626 1.408 1.35 0 .724-.613 1.35-1.409 1.35s-1.409-.626-1.409-1.35Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M14.768 9.25c-.493 0-.97.35-1.045.898l-.174 1.18c-.158.08-.31.168-.455.26l-1.168-.457-.007-.002a1.055 1.055 0 0 0-1.29.456l-1.23 2.068a1.04 1.04 0 0 0 .261 1.364l.003.002.97.737a4.323 4.323 0 0 0 0 .488l-.97.737-.003.002c-.426.327-.52.904-.271 1.346l.004.008 1.235 2.078c.28.486.848.613 1.275.462l.011-.004 1.177-.46c.148.094.3.18.458.26l.174 1.18c.075.547.552.897 1.045.897h2.467c.493 0 .97-.35 1.045-.898l.174-1.18c.158-.08.31-.168.455-.26l1.168.457.006.002c.468.178 1.024.009 1.292-.456l1.235-2.078.004-.008a1.047 1.047 0 0 0-.271-1.346l-.972-.74a4.367 4.367 0 0 0 0-.487l.969-.737.003-.002c.426-.327.52-.903.271-1.346l-.005-.008-1.235-2.078c-.279-.486-.847-.613-1.274-.462l-.012.004-1.176.46c-.148-.094-.3-.18-.458-.26l-.174-1.18a1.048 1.048 0 0 0-1.045-.897h-2.467Zm.142 3.129.24-1.629h1.703l.24 1.629.4.16c.312.124.6.288.872.492l.334.25 1.573-.615.836 1.406-1.323 1.006.056.43c.022.177.037.333.037.492 0 .159-.015.315-.037.492l-.056.43 1.323 1.006-.836 1.406-1.568-.612-.332.242a4.025 4.025 0 0 1-.878.497l-.401.16-.24 1.629H15.15l-.24-1.629-.401-.16a3.79 3.79 0 0 1-.871-.491l-.334-.25-1.573.614-.836-1.406 1.322-1.006-.055-.43a3.886 3.886 0 0 1-.037-.492c0-.153.014-.316.037-.492l.055-.43-1.322-1.006.836-1.406 1.568.612.332-.242a4.03 4.03 0 0 1 .878-.497l.401-.16Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgHomeSetting;
